import styled from "styled-components";

import { PartnerBankColors } from "@ctypes";

export const Card = styled.div<{ $colors: PartnerBankColors }>`
  position: relative;
  margin-top: 36px;
  width: 338px;
  max-width: 100%;
  border-radius: 20px;
  padding: 24px;
  background: ${({ $colors }) => $colors.infoCard};
  border: ${({ $colors }) =>
    $colors.infoCardBorder ? `1px solid ${$colors.infoCardBorder}` : "none"};
`;

export const Feature = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  & + & {
    margin-top: 20px;
  }
`;

export const FeatureIcon = styled.div`
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid #ffffff;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeatureTitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #f5f0eb;
`;

export const FeatureSubtitle = styled.p<{ $color: string }>`
  margin: 4px 0 0;
  font-size: 11px;
  line-height: 1.5;
  color: ${({ $color }) => $color};
`;

export const Motivational = styled.div<{ $colors: PartnerBankColors }>`
  margin-top: 28px;
  border-radius: 10px;
  padding: 14px;
  text-align: center;
  font-family: "Playfair Display", serif;
  font-size: 16px;
  line-height: 1.3;
  color: #f5f0eb;
  background: ${({ $colors }) => $colors.motivational};
`;
